<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.8 2.5C10.8 2.05817 10.4418 1.7 10 1.7C9.55817 1.7 9.2 2.05817 9.2 2.5V10.5688L6.39881 7.7676C6.08639 7.45518 5.57986 7.45518 5.26744 7.7676C4.95502 8.08002 4.95502 8.58655 5.26744 8.89897L9.43411 13.0656C9.51878 13.1503 9.61772 13.212 9.72318 13.2508C9.80944 13.2826 9.90269 13.3 10 13.3C10.227 13.3 10.432 13.2054 10.5776 13.0535L14.7321 8.89897C15.0446 8.58655 15.0446 8.08002 14.7321 7.7676C14.4197 7.45518 13.9132 7.45518 13.6008 7.7676L10.8 10.5684V2.5ZM2.5 11.7C2.94182 11.7 3.3 12.0582 3.3 12.5V15.8333C3.3 16.0632 3.39131 16.2836 3.55384 16.4462C3.71637 16.6087 3.93681 16.7 4.16666 16.7H15.8333C16.0632 16.7 16.2836 16.6087 16.4462 16.4462C16.6087 16.2836 16.7 16.0632 16.7 15.8333V12.5C16.7 12.0582 17.0582 11.7 17.5 11.7C17.9418 11.7 18.3 12.0582 18.3 12.5V15.8333C18.3 16.4875 18.0401 17.1149 17.5775 17.5775C17.1149 18.0401 16.4875 18.3 15.8333 18.3H4.16666C3.51246 18.3 2.88506 18.0401 2.42247 17.5775C1.95988 17.1149 1.7 16.4875 1.7 15.8333V12.5C1.7 12.0582 2.05817 11.7 2.5 11.7Z"
      fill="currentColor"
    />
  </svg>
</template>
